<template>
	<div class="app">
	    <div class="my-exam">
			<router-link class="my-exam__a" to="/user/myClassroom">我的班级</router-link>
			<router-link class="my-exam__a" to="/user/myCourse">我的课程</router-link>
			<router-link class="my-exam__aa" to="/user/myExam">练习中心</router-link>
	    </div>
	    <div class="my-exam-tab">
			<div class="my-exam-tab__top">
				<a class="my-exam-tab__topn">1000题</a>
				<a class="my-exam-tab__topn">100套试卷</a>
				<a class="my-exam-tab__topn">30个知识点</a>
				<div class="my-exam-tab__topleft" @click="popup">{{classes}}</div>
			</div>
	    </div>
		<!-- 中部主内容 -->
	    <div class="examMain">
			<div class="middlep">
				<van-row>
					<van-col span="8">
						<div align="center" class="middlep-img"><img src="@/assets/user/wd1.png" /></div>
					</van-col>
				    <van-col span="8">
						<div align="center"  class="middlep-img" @click="getExamQuestions('/user/ExamBank')"><img src="@/assets/user/wd1.png" /></div>
					</van-col>
				    <van-col span="8">
						<div align="center" class="middlep-img" @click="url('/user/ExamRecord')"><img src="@/assets/user/wd1.png" /></div>
					</van-col>
					<van-col class="middlep_text" span="8" ><a>练习中心</a></van-col>
					<van-col class="middlep_text" span="8" ><a @click="getExamQuestions('/user/ExamBank')">套卷练习</a></van-col>
					<van-col class="middlep_text" span="8"><a @click="url('/user/ExamRecord')">考试记录</a></van-col>
					<van-col span="8">
						<div align="center" class="middlep-img"><img src="@/assets/user/wd1.png" /></div>
					</van-col>
				    <van-col span="8">
						<div align="center" class="middlep-img" @click="url('/user/ErrorBank')"><img src="@/assets/user/wd1.png" /></div>
					</van-col>
				    <van-col span="8">
						<div align="center" class="middlep-img" @click="url('/user/CollectBank')"><img src="@/assets/user/wd1.png" /></div>
					</van-col>
					<van-col class="middlep_text" span="8"><a >练习记录</a></van-col>
					<van-col class="middlep_text" span="8"><a @click="url('/user/ErrorBank')">错题练习</a></van-col>
					<van-col class="middlep_text" span="8"><a @click="url('/user/CollectBank')">收藏练习</a></van-col>
				</van-row>
			</div>
			<!-- 图表 -->
			<div class="chart">
				<canvas id="myChart"></canvas>
			</div>
	    </div>
		<!-- 底部内容 -->
		<div class="examBottom">
			<!-- 学习时间记录 -->
			<div class="learn-card">
				<van-row>
					<van-col span="8" class="learn-card__siz">连续学习</van-col>
					<van-col span="8" class="learn-card__siz">学习时间</van-col>
					<van-col span="8" class="learn-card__siz">正确率</van-col>
					<van-col span="8" class="learn-card__siz"><span class="learn-card__span">5</span>天</van-col>
					<van-col span="8" class="learn-card__siz"><span class="learn-card__span">9.5</span>小时</van-col>
					<van-col span="8" class="learn-card__siz"><span class="learn-card__span">80</span>%</van-col>
				</van-row>
			</div>
			<div class="examBottom-position">
				<!-- 气泡显示 -->
				<div class="qpIcon">
					<div class="qpIcon-box">
						<img src="../../assets/user/qp1.png" />
						<span>10/30知识点</span>
					</div>
					<div class="qpIcon-box">
						<img src="../../assets/user/qp2.png" />
						<span>30/100试卷</span>
					</div>
					<div class="qpIcon-box">
						<img src="../../assets/user/qp3.png" />
						<span>500/1000题</span>
					</div>
				</div>
				<!-- 学习进度显示 -->
				<div class="progress-position">
					<div class="progress-bar1" :style="{width:knowledgePro+'%',zIndex:knowledgeNum}">	
					</div>
					<div class="progress-bar2" :style="{width:examPro+'%',zIndex:examNum}">	
					</div>
					<div class="progress-bar3" :style="{width:bankPro+'%',zIndex:bankNum}">
					</div>
				</div>
				<div class="bottom-btn" >继续上次练习</div>
			</div>
		</div>
		<!-- 底部弹出层 -->
		
		<!-- 点击考试选择弹出弹出层 -->
		<van-popup class="popup"  v-model="showPopup" position="right" >
			<div class="popup-box">
				<div class="popup_title">已选考试</div>
				<!-- <Button>{{classes}}</Button> -->
				<van-button class="van-btns" type="default" v-if="classes=='未选择'">{{classes}}</van-button>
				<van-button class="van-btns active" type="default" v-else>{{classes}}</van-button>
				<div v-for="(classes,index) in allClass" :key="index">
					<div class="popup_title">
						<div>{{classes.categoryname}}</div>
						<div class="popup-subBox">
							<div v-for="(child,index) in classes.childs" :key="index" class="margin-right20" @click="setClasses(child.categoryid,child.categoryname)">
								<!-- <Button >{{child.categoryname}}</Button> -->
								<van-button class="van-btns" :class="{active:active==child.categoryid}" type="default">{{child.categoryname}}</van-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</van-popup>	
		<!-- 弹出层底部按钮 -->
		<div class="popup-btn" v-if="showPopup" >
			<div class="popup-btn-left" @click="resetClasses">重置</div>
			<div class="popup-btn-right" @click="trueClasses">确定</div>
		</div>
		
	</div>
</template>
<script>
	import {GetPaperList,GetAllExamCategory} from '@/apis/exam'
export default{
	name:'MyExam',
	data(){
		return {
			knowledgePro:60,//知识点进度条
			examPro:40,//套卷进度条
			bankPro:50,//题库进度条
			knowledgeNum:null,//显示层级
			examNum:null,//显示层级
			bankNum:null,//显示层级
			percentage:40,//进度条
			showPopup:false,//弹出层开关
			btnText:'英语考试',//
			allClass:[],//所有课程
			id:null,//课程id
			classes:'未选择',//课程名称
			active:null,//当前未选中
		}
	},
	methods:{
		url(url) { // 页面跳转
			this.$router.push(url)
		},
		// 弹出层开关
		popup(){
			this.showPopup = true
		},
		// 选择课程并存储
		setClasses(id,classes){
			this.classes = classes
			this.id = id
			localStorage.classes = classes
			localStorage.id = id
			this.active = id
		},
		// 重置选中的课程
		resetClasses(){
			this.classes = '未选择'
			this.active = 0
			localStorage.classes = '未选择'
			localStorage.id = 0
		},
		// 确定课程返回页面
		trueClasses(){
			this.showPopup = false
		},
		//获取考试题目
		getExamQuestions(url){
			// if(localStorage.id!=0){
			// 	var id = localStorage.id
			// 	this.$router.push({
			// 		name:'MyExam',
			// 		query:{
			// 			categoryid:id
			// 		}
			// 	})
			// 	
			// }
			this.$router.push(url)
		},
		// 图表
		chart(){
			var ctx = document.getElementById('myChart').getContext('2d');
			var chart = new Chart(ctx, {
			    // The type of chart we want to create
			    type: 'line',
			    // The data for our dataset
			    data: {
			        labels: ['4.15', '4.16', '4.17', '4.18', '今天','4.20', '4.21'],
			        datasets: [{
			            label: '单位:小时',
						backgroundColor:'rgb(255, 255, 255)',//线条背景色
			            borderColor: 'rgb(244, 80, 80)',//线色
			            data: [3.5,0.5, 2, 2.5, 2, 2.5],//数据
						bezierCurve : true,
						borderWidth:1,//线宽
						fill: false,  //不填补线下区域
			        }]
			    },
			    // Configuration options go here
			    options: {
					layout: {
						padding: {
						    left: 0,
						    right: 0,
						    top: 10,
						    bottom: 10
						}
					},
					elements: {
						line: {
							tension: 0 // disables bezier curves
						}
					},
					scales: {
						yAxes: [{
							ticks: {
								beginAtZero: true,
								type: 'category',
								labels: ['小时', 0, 0.5, 1, 1.5,2, 2.5,3,3.5]
							}
						}],
						xAxes: [{
						    type: 'category',
						    labels: ['4.14','4.15', '4.16', '4.17', '4.18', '今天','4.20', '4.21'],
							ticks: {
								min: '4.15'//从4.15开始
							}
						}]
					}		
				}
			});
		}
	},
	created() {//实例未渲染前初始化数据
		// 获取用户课程记录
		if(localStorage.classes){
			this.classes = localStorage.classes
		}
		// 进度条比较大小，小的层级最大显示
		if(this.knowledgePro>=this.bankPro&&this.examPro){
			this.knowledgeNum = 1
			if(this.bankPro>=this.examPro){
				this.bankNum = 2
				this.examNum = 3
			}else{
				this.bankNum = 3
				this.examNum = 2
			}
		}else if(this.bankPro>=this.knowledgePro&&this.examPro){
			this.bankNum = 1
			if(this.knowledgePro>=this.examPro){
				this.knowledgeNum = 2
				this.examNum = 3
			}else{
				this.knowledgeNum = 3
				this.examNum = 2
			}
		}else if(this.examPro>=this.knowledgePro&&this.bankPro){
			this.examNum = 1
			if(this.knowledgePro>=this.bankPro){
				this.knowledgeNum = 2
				this.bankNum = 3
			}else{
				this.knowledgeNum = 3
				this.bankNum = 2
			}
		}
			
		
		//请求接口获取一级课程列表
		GetAllExamCategory({
			schoolid: SCHOOL_ID
		}).then(res=>{
			console.log(res)
			this.allClass = res.data
			localStorage.allClass = JSON.stringify(res.data)
		})
	},
	mounted(){//实例渲染后执行
		this.chart()
	},
	activated(){
	  document.title = '练习中心'
	},
	
}
</script>
<style scoped>
    .app{
		background-color:#fff ;
		width: 100%;
		min-height: 100vh;
		position: relative;
		padding: 0;
		margin: 0;	
    }
    .middlep{
		background-color:#fff;
		width: 100%;
		height:160px;
		border-radius: 10px;	
    }
    .my-exam-tab{
		background-color:#fff;
		width: 100%;
		height: 39.5px;
    }
    .my-exam{
		height: 35px;
		background-color: #fff;
    }
    .my-exam__a{
		font-size: 16px;
		margin:0 10px 0 20px;
		line-height:40px;
		font-weight:bolder;
		font-family:PingFang-SC-Bold;
		color:rgba(51,51,51,1);
		margin-top:14.5px;
    }
    .my-exam__aa{
		font-size: 16px;
		margin:0 10px 0 20px;
		font-weight:bolder;
		font-family:PingFang-SC-Bold;
		color:rgba(251,110,82,1);
    }
    .my-exam-tab__top{
		margin: 0px 14px;
    }
    .my-exam-tab__topn{
		color:#9E9E9E;
		float: left;
		margin-right:3vw;
		font-size: 13px;
		margin-top: 18px;
    }
    .my-exam-tab__topn:hover{
		color:orange;
		float: left;
		margin-right:35px;
		font-size: 13px;
		margin-top: 18px;
    }
    .my-exam-tab__topleft{
		color:#858585;
		float: right;
		margin-top: 13px;
		font-size: 15px;
    }
	.examMain{
		width: 94%;
		padding: 6px 3% 50px 3%;
		background: #F1F2F4;
	}
	
	/* 弹出层 */
	.van-btns{
		border:1px solid #ddd;
		color: #777;
		border-radius: 5px;
	}
	.active{
		color: #fff;
		background: #FF795C;
		border:1px solid #FF795C;
	}
	.popup{
		width: 80%;
		height: 100vh;
		position: absolute;
		bottom: 0;
		left: 20%;	
	}
	.popup-box{
		padding: 0 10px 0 10px;
		overflow: hidden;
		margin-bottom: 50px;
	}
	.popup_title{
		color: #333;
		font-size: 4vw;
		padding: 18px 0;
	}
	.popup-subBox{
		display: flex;
		margin-top: 10px;
		flex-wrap:wrap;
	}
	.margin-right20{
		margin-right: 20px;
		margin-top: 10px;
	}
	.popup-btn{
		width:80%;
		height:45px;
		background:rgba(249,249,249,1);
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 3000;
		display: flex;
		font-size: 5vw;
	}
	.popup-btn-left{
		width: 50%;
		color: #333;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.popup-btn-right{
		width: 50%;
		background: #FF795C;
		color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}	
	/* 图表 */
    .chart{
		background-color:#fff;
		width: 100%;
		margin-top:10px;
		border-radius: 10px;
    }
	/* 底部内容 */
	.examBottom{
		width: 94%;
		padding: 0 3%;
		position: relative;
	}
    .learn-card{
		background-color:#fff;
		width: 94%;
		height: 90px;
		margin-top:10px;
		border-radius: 10px;
		overflow: hidden;
		position: absolute;
		top: -50px;
		left: 3%;
		border: 1px solid #F1F2F4;
		box-shadow: 0px 1px 0px #FDDCDC;
    }
    .learn-card__siz{
		text-align: center;
		margin-top:13px;
		font-size: 15px;
		color:rgba(51,51,51,1);
    }
	.examBottom-position{
		width: 94%;
		padding: 0 3%;
		position: absolute;
		background: #fff;
		top: 55px;
		left: 0;
	}
    .middlep_icon {
		margin:30px 65px 10px;
		text-align:center;
    }
    .middlep_text{
		text-align:center;
		color: #858585;
		font-size: 13px;
		font-family:PingFangSC-Regular;
    }
    .bottom-btn{
		width: 94%;
		margin: 0 auto;
		height: 5vh;
		font-size: 15px;
		color: #fff;
		background-color: #ea6f5a;
		border-radius: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
		font-weight: 400;
		vertical-align: middle;
		touch-action: manipulation;
		cursor: pointer;
		background-image: none;
		border: 1px solid transparent;
		white-space: nowrap;
		width: 100%;
		margin-top: 10px;
    }
    .middlep-img{
    	margin-top:20px;
    }
	/* 气泡显示 */
	.qpIcon{
		width: 100%;
		height: 3rem;
		display: flex;
		align-items: center;
		
	}
	.qpIcon-box{
		width: 33.3%;
		height: 2rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.qpIcon-box img{
		width: 22px;
		height: 22px;
	}
	/* 进度条 */
	.progress-position{
		position: relative;
		width: 100%;
		height: 5px;
		margin-bottom: 1rem;
		border-radius: 3px;
		background: #FDDCDC;
	}
    .progress-bar1{
		height: 5px;
		background: #F45050;
		border-radius: 3px;
		position:absolute;
		top: 0;
		left: 0;
    }
	.progress-bar2{
		height: 5px;
		background: #CCE198;
		border-radius: 3px;
		position:absolute;
		top: 0;
		left: 0;
	}
	.progress-bar3{
		height: 5px;
		background: #FF8D2B;
		border-radius: 3px;
		position:absolute;
		top: 0;
		left: 0;
	}
    .learn-card__span{
		font-size: 24px;
    }
    .van-progress {
		height: 5px;
		position: relative;
		border-radius: 5px;
		background: #fddcdc;
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/MyExam.vue